import { getAppAttribution } from "./attributionController.js";

export const SIGNUP_ATTRIBUTION_KEY = Symbol("signupAttribution");

// The page-entry controller owns capture. Auth views only consume its snapshot.
export function createSignupAttributionSession({ controller = getAppAttribution() } = {}) {
  let disposed = false;
  return {
    getAttribution() {
      try { return disposed ? null : controller?.getAttribution() || null; } catch { return null; }
    },
    dispose() { disposed = true; },
  };
}
